import * as React from "react";
import { FunctionComponent, RefObject } from "react";
import {
  TranslatedModule,
  ImagesModuleSettings,
  ContainerQueries,
  ColorScheme,
  Language,
  Accommodation,
  HeaderMenuVariant,
  ActionLinkItem,
} from "../types";
import ImagesModule from "./Modules/ImagesModule";
import SplitMainMenu from "./SplitMainMenu";
import HeaderActionLinks from "./HeaderActionLinks";
import HeaderActionBottomBar from "./HeaderActionBottomBar";
import * as ClassNames from "classnames";
import { getImageModuleWithFixedAspectRatio } from "../utils/utils";

interface Props {
  imagesModule?: TranslatedModule<ImagesModuleSettings>;
  isPreview: boolean;
  queries: ContainerQueries;
  pageId: string;
  scheme: ColorScheme;
  languageId: Language;
  activePagePath: string[];
  actionLinks: ActionLinkItem[];
  accommodation: Accommodation | undefined;
  variant: HeaderMenuVariant;
  intersectionTriggerRef: RefObject<HTMLElement>;
  showSouthTyrolLogo: boolean;
}

const HeaderWithSplitMenu: FunctionComponent<Props> = ({
  imagesModule,
  isPreview,
  pageId,
  queries,
  scheme,
  languageId,
  activePagePath,
  actionLinks,
  accommodation,
  variant,
  intersectionTriggerRef,
  showSouthTyrolLogo,
}) => (
  <div
    className={ClassNames("HeaderModule__Inner", "HeaderModule__Inner--wide", {
      "HeaderModule__Inner--full-height": !isPreview,
    })}
  >
    <SplitMainMenu
      isPreview={isPreview}
      languageId={languageId}
      pageId={pageId}
      activePagePath={activePagePath}
      scheme={scheme}
      variant={variant}
      outerWrapperRef={intersectionTriggerRef}
      showSouthTyrolLogo={showSouthTyrolLogo}
    />

    {imagesModule && imagesModule.pageId && (
      <ImagesModule
        translatedModule={getImageModuleWithFixedAspectRatio(imagesModule)}
        isPreview={isPreview}
        isLayoutPreview={false}
        pageId={pageId}
        queries={queries}
        isActive={false}
        isInsideHeader={true}
        isFirstOnPage={false}
        parentScheme={scheme}
        activeModuleId={undefined}
        fullHeight={!isPreview}
      />
    )}

    {variant === "top-bottom-bars" && (
      <HeaderActionBottomBar
        accommodation={accommodation}
        actionLinks={actionLinks}
        isPreview={isPreview}
        scheme={scheme}
      />
    )}

    {variant === "bottom-bar" && (
      <div className="HeaderModule__InnerOverlay HeaderModule__InnerOverlay--split-menu">
        <HeaderActionLinks
          languageId={languageId}
          accommodation={accommodation}
          isPreview={isPreview}
          actionLinks={actionLinks}
        />
      </div>
    )}
  </div>
);

export default HeaderWithSplitMenu;
